import { Message } from '@hello-pimster/pimster-crm-sdk';

/**
 * Messages Reducer
 */
export enum MessagesActionType {
    /** Object */
    ADD = 'add_message',
    UPSERT = 'upsert_message',
    /** Array */
    SET = 'set_messages',
}

export type MessagesAction =
    | {
          type: MessagesActionType.UPSERT | MessagesActionType.ADD;
          payload: Message;
      }
    | { type: MessagesActionType.SET; payload: Message[] };

export const messagesReducer = (state: Message[], action: MessagesAction) => {
    switch (action.type) {
        case MessagesActionType.UPSERT:
            const messageIdx = state.findIndex(
                (val) => val.id === action.payload.id
            );
            if (messageIdx > -1) {
                state[messageIdx] = action.payload;
                break;
            }
        case MessagesActionType.ADD:
            state.push(action.payload);
            break;
        case MessagesActionType.SET:
            state = action.payload;
            break;
        default:
            break;
    }
    return [...state];
};
